/*
	DO NOT MODIFY MANUALLY
	Generated by: generateModel.ts
*/

import { InvestmentStatusValues } from '../types/utils';

export class InvestmentStatusChangeLogEntry {
	data?: string

	createdAt?: Date

	status: InvestmentStatusValues = InvestmentStatusValues.AWAITING_PAYMENT
}